import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import common from './reducers/common'
import setting from './reducers/setting'
import myInfo from './reducers/myInfo'
import asset from './reducers/asset'
import payment from './reducers/payment'
import center from './reducers/center'
import join from './reducers/join'
import find from './reducers/find'
import scrap from './reducers/scrap'
import slip from './reducers/slip'
import main from './reducers/main'
import report from './reducers/report'
import manage from './reducers/manage'
import tax from './reducers/tax'
import debt from './reducers/debt'
import consulting from './reducers/consulting'

export default combineReducers({
  common,
  setting,
  myInfo,
  slip,
  asset,
  payment,
  center,
  join,
  find,
  scrap,
  main,
  report,
  manage,
  tax,
  debt,
  consulting,
  router: routerReducer
});


// WEBPACK FOOTER //
// ./src/reducer.js